import React from 'react'
import clsx from 'clsx'
import { Checkbox } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '0',
    padding: '0'
  }
}))

const StyledCheckbox = ({ className = undefined, ...props }) => {
  const classes = useStyles(props)

  return (
    <Checkbox
      className={clsx(classes.root, className)}
      size='small'
      color='primary'
      {...props}
    />
  )
}

export default StyledCheckbox
